import React, { useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';

import SideBar from 'components/common/SideBar/SideBar';

import { MdaDialogStep } from './dialog.enums';
import SignMdaDialog from './SignMdaDialog/SignMdaDialog';
import DeclineMdaDialog from './DeclineMdaDialog/DeclineMdaDialog';

interface MdaDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const MdaDialog = ({ isOpen, setIsOpen }: MdaDialogProps) => {
  const [dialogStep, setDialogStep] = useState<MdaDialogStep>(MdaDialogStep.Sign);

  useEffect(() => {
    if (isOpen) {
      setDialogStep(MdaDialogStep.Sign);
    }
  }, [isOpen]);

  return (
    <>
      <SideBar
        title="Welcome to HFS Contractor Portal"
        isOpen={isOpen}
        enableBackdropClick={false}
        showCloseIcon={false}
      >
        {dialogStep === MdaDialogStep.Sign && (
          <SignMdaDialog changeDialogStep={() => setDialogStep(MdaDialogStep.Decline)} setIsOpen={setIsOpen} />
        )}
        {dialogStep === MdaDialogStep.Decline && (
          <DeclineMdaDialog changeDialogStep={() => setDialogStep(MdaDialogStep.Sign)} setIsOpen={setIsOpen} />
        )}
      </SideBar>
    </>
  );
};

export default observer(MdaDialog);
